package com.yendo.mx.repository

import io.ktor.client.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

// El molde exacto para atrapar el Token que nos escupe Mercado Pago
@Serializable
data class CardTokenResponse(val id: String)

object MercadoPagoRepository {
    // Cliente HTTP nativo de Kotlin Multiplatform
    private val client = HttpClient()

    // 🚨 REEMPLAZA ESTO CON TU PUBLIC_KEY DE MERCADO PAGO (Las que empiezan con APP_USR- o TEST-)
    // NUNCA pongas aquí tu Access Token privada.
    private const val PUBLIC_KEY = "APP_USR-ff2fd033-aae6-4a55-b9ed-b3e0e4249492"


    suspend fun generarTokenReal(
        numero: String,
        mes: Int,
        año: Int,
        cvv: String,
        titular: String
    ): String? {
        return try {
            println("[DEBUG] Usando PublicKey: $PUBLIC_KEY")
            val response = client.post("https://api.mercadopago.com/v1/card_tokens?public_key=$PUBLIC_KEY") {
                contentType(ContentType.Application.Json)
                // Armamos el paquete exactamente como lo exige la API de MP
                setBody(
                    """
                    {
                        "card_number": "$numero",
                        "expiration_month": $mes,
                        "expiration_year": $año,
                        "security_code": "$cvv",
                        "cardholder": {
                            "name": "$titular"
                        }
                    }
                    """.trimIndent()
                )
            }

            // HttpStatusCode.Created (201) o OK (200) significa éxito
            if (response.status.value in 200..299) {
                val jsonBody = response.bodyAsText()
                // Ignoramos la basura que manda MP y solo agarramos el 'id'
                val data = Json { ignoreUnknownKeys = true }.decodeFromString<CardTokenResponse>(jsonBody)
                println("YENDO_LOG MP: Token Temporal Generado: ${data.id}")
                data.id
            } else {
                println("YENDO_ERROR: MP rechazó la tarjeta. Status: ${response.status.value} - ${response.bodyAsText()}")
                null
            }
        } catch (e: Exception) {
            println("YENDO_ERROR: Falla de red al contactar MP - ${e.message}")
            null
        }
    }

    suspend fun generarTokenConTarjetaGuardada(cardId: String, cvv: String): String? {
        return try {
            val response = client.post("https://api.mercadopago.com/v1/card_tokens?public_key=$PUBLIC_KEY") {
                contentType(ContentType.Application.Json)
                setBody("""{"card_id": "$cardId", "security_code": "$cvv"}""")
            }
            if (response.status.value in 200..299) {
                val jsonBody = response.bodyAsText()
                val data = Json { ignoreUnknownKeys = true }.decodeFromString<CardTokenResponse>(jsonBody)
                data.id
            } else {
                // 🚀 ESTO TE SALVARÁ LA VIDA: Imprime el error real de Mercado Pago
                println("🚨 ERROR MP CVV: ${response.status.value} - ${response.bodyAsText()}")
                null
            }
        } catch (e: Exception) {
            println("🚨 ERROR KTOR MP: ${e.message}")
            null
        }
    }
}